import { render, staticRenderFns } from "./FormTaxPph22.vue?vue&type=template&id=e5f318e2"
import script from "./FormTaxPph22.vue?vue&type=script&lang=js"
export * from "./FormTaxPph22.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports